<template>
  <div class="row">
    <div class="col-md-12">
      <p>
        <a class="btn btn-success" href="javascript:void(0);" @click="collapse = !collapse">
          Download template memo <i class="fa fa-download"></i>
        </a>
      </p>
      <div v-if="!collapse">
        <div class="card card-body">
          <div class="row">
            <CustomMulti
              :label="$t('document_name')"
              size="6"
              :query="documentName"
              :list="documentNameList"
              :model="form.document_name"
              @data="setValue('document_name', $event)"
            />
            <div class="col-md-6">
              <label class="control-label">&nbsp;</label>
              <div>
                <a class="btn btn-info" v-if="form.document_name" :href="form.document_name.link_file" target="_blank"><i class="fa fa-download"></i></a>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top:10px">
            <div class="col-md-12">
              <p>
                Silakan langsung edit pada <b style="font-weight:900;">Isi Memo</b>, abaikan bagian <b style="font-weight:900;">Pembuka Memo</b> karena data akan tergenerete secara otomatis oleh sistem.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="card card-body printableArea">
        <h3>
          <b>{{ 'Daftar Drafting Dibatalkan' }}</b>
          <!-- <span class="pull-right">#5669626</span> -->
        </h3>
        <hr>
        <div class="row">
          <div class="col-md-12">
            <Datatables table-name="drafting_file_retracted" @doDetail="doDetail" @doEdit="doEdit" @doDelete="doDelete" :action="true" :columnFiltering="true" :trigger="{status:3}" action-data="row_number" :url="'drafting-file'" :dtfields="headers">
              <template slot-scope="props">
              <div class="btn-group btn-sm" role="group" aria-label="Basic example">
                <button type="button" data-action="doDetail" class="btn btn-success btn-sm"><i class="mdi mdi-magnify"></i></button>
                <!-- <button type="button" data-action="doEdit" class="btn btn-warning btn-sm"><i class="mdi mdi-grease-pencil"></i></button>
                <button v-if="props.ctx.data.deleteable" type="button" data-action="doDelete" class="btn btn-danger btn-sm"><i class="fa fa-times"></i></button> -->
              </div>
              </template>
            </Datatables>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data() {
    let _this = this
    return {
      documentNameList:[],
      collapse:true,
      form:{
        document_name:null
      },
      headers:{
        agenda_number:{
          label:'Nomor Agenda',
          data:'agenda_number',
        },
        subject:{
          label:'Perihal',
          data:'subject',
        },
        document_date:{
          label:'Tanggal',
          data:'document_date',
          render:function(data){
            return new Date(data).toDateString();
          }
        },
        // document_number:{
        //   label:'Nomor Memo',
        //   data:'document_number',
        // },
        sender_id:{
          label:'Penanda Tangan',
          data:'sender.name',
        },
        created_by:{
          label:'Drafter',
          data:'creator.name',
        },
        final_approved:{
          label:'Status',
          data:'final_approvement.name',
          render:function(data){
            return _this.$t(data)
          }
        },
      }
    };
  },
  computed: {
  },
  mounted() {
    const state = {
      loaded: false,
      isAdd:false,
      isEdit:false,
      isDetail:false,
    };
    this.$store.commit("drafting_file_retracted/STATE", state);
  },
  methods: {
    setValue(model, data) {
			this.form[model] = data;
		},
    documentName(query) {
			axios.get(`clasification/list-active?s=${query}`).then((res) => {
				this.documentNameList = res.data.items;
			});
		},
    doDetail(val) {
      this.$store.dispatch("drafting_file_retracted/onDetail", val);
      // const idsurat = val.id;
      // let route = this.$router.resolve({path: '/drafting-file/detail'});
      // let route1 = `${route.href}/${idsurat}`;
      // window.open(route1,'_blank');
    },
    doEdit(val) {
      this.$store.dispatch("drafting_file_retracted/onEdit", val);
    },
    doDelete(val){
      this.$store.dispatch("drafting_file_retracted/onDelete", val);
    }
  }
};
</script>
